import slugify from 'react-slugify'

import { GuideMarkdownTailwind } from '@app/components/Guide/ui/GuideMarkdownTailwind'

import { ContentSectionBlockType } from './types'

interface ContentSectionBlockProps {
  block: ContentSectionBlockType
}

export const ContentSectionBlock = ({ block }: ContentSectionBlockProps) => {
  if (!block.body) return null

  return (
    <section className="space-y-2">
      {block.Title && (
        <h3
          id={slugify(block.Title)}
          className="scroll-mt-[70px] text-xl font-bold leading-[150%] tracking-[0.32px] text-foreground"
        >
          {block.Title}
        </h3>
      )}
      <GuideMarkdownTailwind markdown={block.body} />
    </section>
  )
}

export default ContentSectionBlock
